import { render, staticRenderFns } from "./fenqiSendMsg.vue?vue&type=template&id=628e75e2&scoped=true&"
import script from "./fenqiSendMsg.vue?vue&type=script&lang=js&"
export * from "./fenqiSendMsg.vue?vue&type=script&lang=js&"
import style0 from "./fenqiSendMsg.vue?vue&type=style&index=0&id=628e75e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628e75e2",
  null
  
)

export default component.exports